import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Skeleton } from '@/components/ui/skeleton';
import { AlertTriangle, AlertCircle, CheckCircle2 } from 'lucide-react';
import { QueueAlert } from '@/hooks/useQueueMonitor';

interface QueueHealthAlertsProps {
  alerts: QueueAlert[] | undefined;
  isLoading?: boolean;
}

/**
 * Componente que exibe alertas de saúde da fila de processamento
 */
export function QueueHealthAlerts({ alerts, isLoading }: QueueHealthAlertsProps) {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Alertas de Saúde</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {[...Array(2)].map((_, i) => (
              <Skeleton key={i} className="h-16 w-full" />
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          Alertas de Saúde
          {!isLoading && alerts && alerts.length === 0 && (
            <CheckCircle2 className="h-5 w-5 text-green-500" />
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {!alerts || alerts.length === 0 ? (
          <Alert className="border-green-500/20 bg-green-500/10">
            <CheckCircle2 className="h-4 w-4 text-green-500" />
            <AlertDescription className="text-green-500">
              Sistema operando normalmente. Nenhum alerta detectado.
            </AlertDescription>
          </Alert>
        ) : (
          <div className="space-y-3">
            {alerts.map((alert) => (
              <Alert 
                key={alert.id}
                className={
                  alert.type === 'error' 
                    ? 'border-red-500/20 bg-red-500/10' 
                    : 'border-yellow-500/20 bg-yellow-500/10'
                }
              >
                {alert.type === 'error' ? (
                  <AlertCircle className="h-4 w-4 text-red-500" />
                ) : (
                  <AlertTriangle className="h-4 w-4 text-yellow-500" />
                )}
                <AlertDescription 
                  className={
                    alert.type === 'error' 
                      ? 'text-red-500' 
                      : 'text-yellow-500'
                  }
                >
                  {alert.message}
                </AlertDescription>
              </Alert>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
